(function ($, window, Drupal) {

    Drupal.behaviors.viewsExposedFilters = {
        attach: function (context, settings) {
            // Hide elements.
            $('.views-exposed-form .bef--secondary .card-header', context).hide();
            $('.views-exposed-form .bef--secondary', context).hide();

            let filterStatus = false;
            $('.view-header .view-filter-toggler', context).click(function () {
                if (filterStatus === false) {
                    $('.views-exposed-form .bef--secondary', context).show();
                    filterStatus = true;
                } else {
                    $('.views-exposed-form .bef--secondary', context).hide();
                    filterStatus = false;
                }
            });
        }
    };

    Drupal.behaviors.viewsSort = {
        attach: function (context, settings) {
            let sortValue = $('select[data-drupal-selector="edit-sort-bef-combine"]', context).val();
            $('.view-sort-by select', context).val(sortValue);

            $('.view-sort-by select', context).on('change', function() {
                $('form[id="views-exposed-form-courses-list-courses-list"] select[name="sort_bef_combine"]', context).val(this.value).change();
                $('form[id="views-exposed-form-courses-list-region"] select[name="sort_bef_combine"]', context).val(this.value).change();
                $('.view-sort-by select option[value="' + this.value + '"]', context).change()
            });

            $('.form-item-sort-bef-combine', context).hide();
        }
    };

})(jQuery, window, Drupal);